import React from 'react';
import {
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Row,
  Col,
} from 'react-bootstrap';
import './styles.scss';
import ChartModal from './ChartModal';
import { injectIntl } from 'react-intl';
import { observer, inject } from 'mobx-react';

@injectIntl
@inject('getStore')
@observer
export default class Get extends React.Component {
  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.submit = this.submit.bind(this);

    this.state = { show: false, active: -1, type: -1, loaded: false, smc: 0 };
  }

  openModal(index, type) {
    if (this.state.active == -1) {
      this.setState({
        show: true,
        active: index,
        type: type,
      });
    }
  }

  handleHide() {
    this.setState({
      show: false,
      active: -1,
      type: -1,
    });
  }

  handleChange(e) {
    if (e.target.value >= 0 && !e.isNil) {
      this.setState({
        smc: e.target.value,
      });
    }
  }

  handleKeyPress(e) {
    if (e.which == 13) {
      this.submit();
    }
  }

  submit() {
    alert('Expecting monetization!');
  }

  render() {
    const { intl } = this.props; // const intl = this.props.intl
    const { getStore } = this.props;
    if (!getStore.loaded) {
      return (
        <div className="main-loader">
          <div className="loader-lg"></div>
        </div>
      );
    }

    let plots = ['daily', 'weekly', 'monthly'];

    return (
      <div>
        <Row>
          <h2 className={'bold text-center'}>
            {intl.formatMessage({ id: 'tendencies_title' })}
          </h2>
        </Row>

        <div>
          <Row>
            {plots.map((item, i) => {
              return (
                <Col xs={4} key={i}>
                  <ChartModal
                    openModal={() => {
                      this.openModal(item, 'startup');
                    }}
                    active={
                      this.state.active == item && this.state.type == 'startup'
                    }
                    handleHide={() => {
                      this.handleHide();
                    }}
                    container={this}
                    closeModal={() => {
                      this.setState({ show: false, active: -1, type: -1 });
                    }}
                    entry={item}
                    label={intl.formatMessage({
                      id: item + '_new_startups_label',
                    })}
                    title={intl.formatMessage({
                      id: item + '_new_startups_title',
                    })}
                    //description={intl.formatMessage({id: item + "_new_startups_description"})}
                    data={getStore.dataStartups}
                  />
                </Col>
              );
            })}
          </Row>

          <Row>
            {plots.map((item, i) => {
              return (
                <Col xs={4} key={i}>
                  <ChartModal
                    openModal={() => {
                      this.openModal(item, 'user');
                    }}
                    active={
                      this.state.active == item && this.state.type == 'user'
                    }
                    handleHide={() => {
                      this.handleHide();
                    }}
                    container={this}
                    closeModal={() => {
                      this.setState({ show: false, active: -1, type: -1 });
                    }}
                    entry={item}
                    label={intl.formatMessage({
                      id: item + '_new_users_label',
                    })}
                    title={intl.formatMessage({
                      id: item + '_new_users_title',
                    })}
                    data={getStore.dataUsers}
                  />
                </Col>
              );
            })}
          </Row>
        </div>
      </div>
    );
  }
}
